<!-- for essentials -->

<!-- Sidebar Overlay -->
<div id="sidebar-overlay" class="fixed inset-0 bg-black/50 z-40 lg:hidden hidden" (click)="toggleSidebar()"></div>

<!-- Sidebar - Essential Plan -->
<aside id="sidebar"
  class="sidebar fixed top-0 left-0 z-50 h-screen w-64 bg-white dark:bg-slate-900 border-r border-gray-100 dark:border-slate-800 -translate-x-full lg:translate-x-0 transition-all duration-300">
  <!-- Logo -->
  <div class="flex items-center justify-between h-16 p-3">
    <div class="flex items-center">
      <!-- <div class="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0">
        <img src="assets/images/logo/Final1.png" alt="icon" class="w-72">
      </div> -->

      <a href="javascript:void(0)" (click)="goToDashboard('home')" class="flex items-center no-underline active" aria-current="page">
        <div class="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0">
          <img src="assets/images/SignPL-Fav.png" alt="icon" class="w-72 img-fluid block"><!--!-->
        </div>

        <span class="sidebar-text ml-1 text-xl font-bold text-gray-900 dark:text-white tracking-tight whitespace-nowrap">
          <img src="assets/images/setting-icon/SignpaperlessLogo_Final-cropped.svg" alt="icon" class="w-72 block dark:hidden"><!--!-->
        </span>
      </a>

      <!-- <span class="sidebar-text ml-3 text-xl font-bold text-gray-900 dark:text-white tracking-tight whitespace-nowrap">
        <img src="assets/images/logo/Sign_paperless_logo_default.svg" alt="icon" class="w-72">
      </span> -->
    </div>
    <button (click)="toggleSidebarCollapse()"
      class="hidden lg:flex w-7 h-7 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
      <i id="collapse-icon" class="fas fa-chevron-left text-xs"></i>
    </button>
  </div>

  <!-- Plan Switcher -->
  <app-plan-switcher></app-plan-switcher>

  <nav class="px-3 py-4 h-[calc(100vh-14rem)] overflow-y-auto space-y-1">
    <!-- Essential Plan Navigation - Simplified -->

    <!-- Main Navigation -->
    <a (click)="goToDashboard('home')" routerLinkActive="nav-item-active" data-nav="dashboard"
      href="javascript:void(0)"
      class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors group cursor-pointer">
      <i
        class="fas fa-th-large w-5 mr-3 text-gray-400 dark:text-gray-500 group-hover:text-indigo-500 flex-shrink-0"></i>
      <span class="sidebar-text">{{ 'HEADER.DASHBOARD' | translate }}</span>
    </a>
 
     @if (hasFormWizSubscriptionTrue && permissions.canViewRecipients) {
      <a (click)="goToDashboard('recipient')" routerLinkActive="nav-item-active" data-nav="dashboard"
        href="javascript:void(0)"
        class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors group cursor-pointer">
        <i class="fas fa-users w-5 mr-3 text-gray-400 dark:text-gray-500 group-hover:text-indigo-500 flex-shrink-0"></i>
        <span class="sidebar-text">{{ 'HEADER.RECIPIENTS' | translate }}</span>
      </a>
    }


   
    @if (hasNormalOrFormWizSubscriptionTrue) {
      
      <div class="sidebar-text my-2 border-t border-gray-100 dark:border-slate-800"></div>

      <button type="button" (click)="toggleAdvanceMenu()"
        class="nav-link w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group cursor-pointer"
        [ngClass]="{ 'nav-item-active': isAdvanceSectionActive, 'hover:bg-gray-100 dark:hover:bg-slate-800': !isAdvanceSectionActive }">
        <div class="flex items-center">
          <!-- <i class="fas fa-layer-group w-5 mr-3 text-gray-400 dark:text-gray-500 flex-shrink-0"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !isAdvanceSectionActive, 'text-white': isAdvanceSectionActive }"></i> -->

            
<i class="fas fa-layer-group w-5 mr-3 text-gray-400 dark:text-gray-500 flex-shrink-0"
   [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !isAdvanceSectionActive }"></i>

          <!-- <span class="sidebar-text" [class.text-white]="isAdvanceSectionActive">{{ 'HEADER.ADVANCE' | translate }}</span> -->
          <span class="sidebar-text">
            {{ 'HEADER.ADVANCE' | translate }}
          </span>
        </div>
        <div class="sidebar-text flex items-center gap-1">
          <span
            class="nav-badge bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-400 text-xs font-semibold px-2 py-0.5 rounded-full">{{
            'COMMON.NEW' | translate }}</span>
          <i class="fas fa-chevron-down text-xs text-gray-400 transition-transform duration-200"
            [class.rotate-180]="isAdvanceMenuOpen"></i>
        </div>
      </button>
      

      @if (isAdvanceMenuOpen) {
      <div class="mt-1 space-y-1 pl-3">
        <a routerLink="/advance" routerLinkActive="nav-item-active" [routerLinkActiveOptions]="{ exact: true }"
          #summaryRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !summaryRla.isActive }">
          <i class="fas fa-clipboard-list w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !summaryRla.isActive, 'text-white': summaryRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="summaryRla.isActive">{{ 'ADVANCE.SUMMARY' | translate }}</span>
        </a>

        @if (hasFormWizSubscriptionTrue  && permissions.canViewQuestions) {
        <a routerLink="/advance/question" routerLinkActive="nav-item-active" #questionRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !questionRla.isActive }">
          <i class="fas fa-question-circle w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !questionRla.isActive, 'text-white': questionRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="questionRla.isActive">{{ 'ADVANCE.QUESTIONS' | translate
            }}</span>
        </a>
        }
        
        @if (hasFormWizSubscriptionTrue  && permissions.canViewDynamicFunctions) {
        <a routerLink="/advance/dynamic-functions" routerLinkActive="nav-item-active" #dynamicRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !dynamicRla.isActive }">
          <i class="fas fa-code w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !dynamicRla.isActive, 'text-white': dynamicRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="dynamicRla.isActive">{{ 'ADVANCE.DYNAMIC_FUNCTIONS' | translate
            }}</span>
        </a>
        }

        @if (hasFormWizSubscriptionTrue  && permissions.canViewRules) {
        <a routerLink="/advance/rules" routerLinkActive="nav-item-active" #rulesRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !rulesRla.isActive }">
          <i class="fas fa-code-branch w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !rulesRla.isActive, 'text-white': rulesRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="rulesRla.isActive">{{ 'ADVANCE.RULES' | translate }}</span>
        </a>
        }

        @if (hasNormalOrFormWizSubscriptionTrue && permissions.canViewDocuments) {
        <a routerLink="/advance/documents" routerLinkActive="nav-item-active" #documentsRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !documentsRla.isActive }">
          <i class="fas fa-folder w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !documentsRla.isActive, 'text-white': documentsRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="documentsRla.isActive">{{ 'ADVANCE.DOCUMENTS' | translate
            }}</span>
        </a>
        } @else if (hasEssentialFormAccess && hasNormalOrFormWizSubscriptionTrue) {
           <a routerLink="/advance/documents" routerLinkActive="nav-item-active" #documentsRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !documentsRla.isActive }">
          <i class="fas fa-folder w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !documentsRla.isActive, 'text-white': documentsRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="documentsRla.isActive">{{ 'ADVANCE.DOCUMENTS' | translate
            }}</span>
        </a>
        }

        @if (hasNormalOrFormWizSubscriptionTrue && permissions.canViewTemplates) {
        <a routerLink="/advance/template" routerLinkActive="nav-item-active" #templateRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !templateRla.isActive }">
          <i class="fas fa-file-alt w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !templateRla.isActive, 'text-white': templateRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="templateRla.isActive">{{ 'ADVANCE.TEMPLATES' | translate
            }}</span>
        </a>
        } @else if(hasEssentialFormAccess && hasNormalOrFormWizSubscriptionTrue){
           <a routerLink="/advance/template" routerLinkActive="nav-item-active" #templateRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !templateRla.isActive }">
          <i class="fas fa-file-alt w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !templateRla.isActive, 'text-white': templateRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="templateRla.isActive">{{ 'ADVANCE.TEMPLATES' | translate
            }}</span>
        </a>
        }

        @if (hasFormWizSubscriptionTrue  && permissions.canViewParticipants) {
        <a routerLink="/advance/participant" routerLinkActive="nav-item-active" #participantRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !participantRla.isActive }">
          <i class="fas fa-user-friends w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !participantRla.isActive, 'text-white': participantRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="participantRla.isActive">{{ 'ADVANCE.PARTICIPANTS' | translate
            }}</span>
        </a>
        }

        @if (hasFormWizSubscriptionTrue && permissions.canViewCategories) {
        <a routerLink="/advance/categories" routerLinkActive="nav-item-active" #categoriesRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !categoriesRla.isActive }">
          <i class="fas fa-tags w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !categoriesRla.isActive, 'text-white': categoriesRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="categoriesRla.isActive">{{ 'ADVANCE.CATEGORIES' | translate
            }}</span>
        </a>
        }

        @if (hasFormWizSubscriptionTrue && permissions.canViewMessagingTemplates) {
        <a routerLink="/advance/messaging-template" routerLinkActive="nav-item-active" #messagingRla="routerLinkActive"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors group"
          [ngClass]="{ 'hover:bg-gray-100 dark:hover:bg-slate-800': !messagingRla.isActive }">
          <i class="fas fa-comment-dots w-5 mr-3 text-gray-400 dark:text-gray-500 transition-colors"
            [ngClass]="{ 'group-hover:text-indigo-500 dark:group-hover:text-indigo-400': !messagingRla.isActive, 'text-white': messagingRla.isActive }"></i>
          <span class="sidebar-text" [class.text-white]="messagingRla.isActive">{{ 'ADVANCE.MESSAGING_TEMPLATES' |
            translate }}</span>
        </a>
        }
      </div>
      }

      <div class="sidebar-text my-2 border-t border-gray-100 dark:border-slate-800"></div>
    }

    <!-- Divider -->
    <!-- Main Navigation -->
    <a (click)="goToDashboard('settings')" routerLinkActive="nav-item-active" data-nav="dashboard"
      href="javascript:void(0)"
      class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors group cursor-pointer">
      <i class="fas fa-cog w-5 mr-3 text-gray-400 dark:text-gray-500 group-hover:text-indigo-500 flex-shrink-0"></i>

      <span class="sidebar-text">{{ 'HEADER.SETTINGS' | translate }}</span>
    </a>
  </nav>

  <!-- User Footer -->
  <app-user-footer></app-user-footer>
</aside>